import { SUPPORT_MESSAGE } from "app/services/global-constants";
import { environment } from "environments/environment";

export class LollyError {
    code: string = null;
    type: "Not Found" | string = null;
    message: string = null;
    developerMessage: string = null;
    exception: Exception;

    constructor(error: string | Partial<LollyError>) {
        if (typeof error === "string") {
            this.message = error;
            this.developerMessage = error;
            this.code = '500';
        } else {
            const message = error?.message ?? null;
            if(message){
                if (message != null) error.message = message.replace("java.lang.RuntimeException:", "");
                if (message != null) error.message = message.replace("java.lang.IllegalArgumentException:", "");
                this.message = error.message ?? SUPPORT_MESSAGE;
            }
         
            this.developerMessage = error.developerMessage ?? SUPPORT_MESSAGE;
            this.code = error.code ?? '500';
            this.type = error.type ?? 'Unknown';
            this.exception = error.exception ?? new Exception();
        }
         
        this.message = environment.showDeveloperErrors ? this.developerMessage : this.message;
    }
}

export class Exception {
    message: string;
    type: string;
    trace: string;
    rootCause?: any;

    constructor() {
        this.message = '';
        this.type = '';
        this.trace = '';
        this.rootCause = null;
    }
}

export class Environment{
    production: boolean = null;
    apiUrl: string;
    lpmKey : string ;
    lpmSecret :string
    VGS_CONFIG: { vaultId: string, environment: string, version:string };
    lollyEndpoint: string
    showDeveloperErrors :boolean ;
    lollyLawAppLink: string;
}

export class ApiResponse{
    status? : 'SUCCESSFUL' | 'ERROR' = null;
    timestamp?: string = null;
    error:string = null;
    message:string = null;
    statusCode:number = null;
}
